import React from "react";

import { Box, Modal as MUIModal } from "@mui/material";

import ModalHeader from "./ModalHeader";

const Modal = ({
  title,
  subTitle,
  open,
  onClose,
  children,
  width,
  height,
  contentOverflow,
}) => {
  const handleModalClose = (event, reason) => {
    // Close via explicit header icon only; ignore backdrop/escape closes.
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    if (typeof onClose === "function") {
      onClose(event, reason);
    }
  };

  const handleHeaderClose = (event) => {
    if (typeof onClose === "function") {
      onClose(event, "closeButton");
    }
  };

  return (
    <MUIModal
      open={open}
      onClose={handleModalClose}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          position: "absolute",
        }}
      >
        <Box
          sx={{
            width: width ? width : "400px",
            height: height ? height : "450px",
          }}
        >
          <ModalHeader
            title={title}
            subTitle={subTitle}
            onClose={handleHeaderClose}
          />
          <Box
            backgroundColor="#f0f0f0"
            height={`calc(${height ? height : "450px"} - 50px)`}
            width={width ? width : "400px"}
            sx={{
              borderBottomLeftRadius: "1rem",
              borderBottomRightRadius: "1rem",
            }}
            overflow={contentOverflow ? contentOverflow : "auto"}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </MUIModal>
  );
};

export default Modal;
